<template>
        <div class="PSContainer">
                <div class="PSContent">
      <h2 class="popup-message-title participationSuccess">{{ $t('participation.success.title__' + result.campaign_type) }}</h2>

      <div class="points">
        <p v-if="result.points_change > 0" class="addPoints">{{ $t('participation.success.points_gained', { points: result.points_change }) }}</p>
        <p v-else class="addPoints">{{ $t('participation.success.points_spent', { points: -1 * result.points_change }) }}</p>
        <p class="yourPoints"><b>{{ $t('participation.success.current_points_text')}}</b> {{ $t('participation.success.current_points_points', {points: result.current_points}) }}</p>
      </div>

      <template v-if="result.campaign_main_type === 'sweepstake'">
        <div class="chanceToWin">
          <b><span>{{ $t('participation.success.chance_to_win_text') }}</span></b> {{ $t('participation.success.chance_to_win_chance', { your: result.chance_user, total: result.chance_total }) }}
        </div>
        <div  class="andNow PSBlock">
          <h3 class="blockHeading"><span>{{ $t('participation.success.heading_what_next') }}</span></h3>
          <p>{{ $t('participation.success.sweep_participate_again_hint',{ points: result.sweep_point_cost }) }}</p>
          <button class="btn-tertiary" @click="participateAgain">{{ $t('participation.success.sweep_participate_again_cta', { points: result.sweep_point_cost }) }}</button>
        </div>
        <div v-if="result.landing_page" class="redirectToSponsor PSBlock">
          <h3 class="blockHeading"><span>{{ $t('participation.success.heading_or') }}</span></h3>
          <span @click="abortRedirectTimer"><circular-count-down-timer class="timer"
            :initial-value="redirectTimer"
            :steps="redirectTimer"
            :size="64"
            :stroke-width="8"
            seconds-fill-color="#fff"
            seconds-stroke-color="#DB5179"
            second-label=""
            underneath-stroke-color="#ddd"
            :paused="redirectPaused"
            @finish="goToLandingpage"
            @update="decTimeLeft"
            ref="countdown"
          /></span>
          <p>{{ $t('participation.success.redirect_hint' + maybeFree)}}</p>
          <a :href="result.landing_page"><img :src="merchantImage" alt="Sponsor Logo"/></a>
          <button v-if="!redirectPaused" @click="abortRedirectTimer" class="btn-secondary">{{ $t('participation.success.redirect_abort') }}</button>
          <a v-if="redirectPaused" :href="result.landing_page" target="_blank" class="btn-tertiary">{{ $t('participation.success.redirect_go_to_merchant') }}</a>
        </div>
      </template>

      <template v-else-if="result.campaign_type === 'coupon/free' && result.coupon_redemption_via_merchant ">
        <div class="showCode PSBlock">
          <h3 class="blockHeading"><span>{{ $t('participation.success.heading_what_next') }}</span></h3>
          <p>{{ result.coupon_redemption_via_merchant_instructions }}</p>
          <button @click="closeOverlay" class="btn-primary" >{{ $t('participation.success.show_merchant_instructions_go_to_campaign') }}</button>
        </div>
        <div v-if="result.landing_page" class="PSBlock">
          <h3 class="blockHeading"><span>{{ $t('participation.success.heading_or') }}</span></h3>
          <p>{{ $t('participation.success.coupon_free_landing_page_heading')}}</p>
          <a class="btn-tertiary" :href="result.landing_page" target="_blank">{{ $t('participation.success.coupon_free_go_to_merchant') }}</a>
        </div>

      </template>

      <template v-else-if="result.campaign_main_type === 'coupon' && result.code">
        <div class="yourCode">
          <b><span>{{ $t('participation.success.coupon_code_heading')}}</span></b>
          <code>{{ result.code }}</code>
        </div>
        <div v-if="result.coupon_redemption_online" class="showCode PSBlock">
          <h3 class="blockHeading"><span>{{ $t('participation.success.heading_what_next') }}</span></h3>
          <p>{{ $t('participation.success.coupon'+maybeFree+'_online_code_hint') }}</p>
          <a class="btn-primary" :href="result.landing_page" @click="copyToClipboard(result.code)">{{ $t('participation.success.coupon'+maybeFree+'_online_redeem_code_cta') }}</a>
          <!-- NOT IMPLEMENTED
            <div class="codes">
            <button class="showQRcode">NOT IMPLEMENTED {{ $t('participation.success.coupon_show_qrcode') }}</button>
            <button class="showBarcode">NOT IMPLEMENTED {{ $t('participation.success.coupon_show_barcode') }}</button>
          </div>
          -->
        </div>
        <div v-if="result.coupon_redemption_offline" class="showCode PSBlock">
          <h3 v-if="!result.coupon_redemption_online" class="blockHeading"><span>{{ $t('participation.success.heading_what_next') }}</span></h3>
          <h3 v-else class="blockHeading"><span>{{ $t('participation.success.heading_or') }}</span></h3>
          <p>{{ $t('participation.success.coupon'+maybeFree+'_show_map_heading')}}</p>
          <img @click="closeOverlay('mapblock')" src="static/letsfamily-de/img/map_placeholder.png" class="mapImage"/>
          <button @click="closeOverlay('mapblock')" class="btn-primary" >{{ $t('participation.success.go_to_map_cta') }}</button>
        </div>
      </template>

      <template v-else-if="result.campaign_main_type === 'coupon' && !result.code">
        <div v-if="result.coupon_redemption_online" class="showCode PSBlock">
          <h3 class="blockHeading"><span>{{ $t('participation.success.heading_what_next') }}</span></h3>
          <p>{{ $t('participation.success.coupon'+maybeFree+'_online_nocode_hint') }}</p>
          <span @click="abortRedirectTimer"><circular-count-down-timer class="timer"
            :initial-value="redirectTimer"
            :steps="redirectTimer"
            :size="64"
            :stroke-width="8"
            seconds-fill-color="#fff"
            seconds-stroke-color="#DB5179"
            second-label=""
            underneath-stroke-color="#ddd"
            :paused="redirectPaused"
            @finish="goToLandingpage"
            @update="decTimeLeft"
            ref="countdown"
          /></span>
          <p>{{ $t('participation.success.redirect_hint' + maybeFree)}}</p>
          <a :href="result.landing_page"><img :src="merchantImage" alt="Sponsor Logo"/></a>
          <button v-if="!redirectPaused" @click="abortRedirectTimer" class="btn-secondary">{{ $t('participation.success.redirect_abort') }}</button>
          <a v-if="redirectPaused" :href="result.landing_page" target="_blank" class="btn-tertiary">{{ $t('participation.success.redirect_go_to_merchant') }}</a>
        </div>

        <div v-if="result.coupon_redemption_offline" class="showCode PSBlock">
          <h3 v-if="!result.coupon_redemption_online" class="blockHeading"><span>{{ $t('participation.success.heading_what_next') }}</span></h3>
          <h3 v-else class="blockHeading"><span>{{ $t('participation.success.heading_or') }}</span></h3>

          <p>{{ $t('participation.success.coupon'+maybeFree+'_show_map_heading')}}</p>

          <div class="yourCode">
            <b><span>{{ $t('participation.success.coupon_no_code_heading')}}</span></b>
            <code>{{ $t('participation.success.coupon_no_code_fake_code')}}</code>
          </div>

          <img  @click="closeOverlay('mapblock')" src="static/letsfamily-de/img/map_placeholder.png" class="mapImage"/>
          <button @click="closeOverlay('mapblock')" class="btn-primary" >{{ $t('participation.success.go_to_map_cta') }}</button>
        </div>
      </template>

      <div class="socialShare PSBlock">
        <h3 class="blockHeading"><span>{{ $t('participation.success.heading_or') }}</span></h3>
        <p>{{ $t('participation.success.share_hint')}}</p>
        <ul>
          <li class="smFacebook"><a :href="'https://www.facebook.com/sharer/sharer.php?u=' + shareUrl" target="_blank"><img src="static/letsfamily-de/img/FB.svg" class="dummySM" style="width:33px; height:33px;" alt="Facebook"></a></li>
          <li class="smTwitter"><a :href="'https://twitter.com/share?url=' + shareUrl " target="_blank"><img src="static/letsfamily-de/img/TWITTER.svg" class="dummySM" style="width:33px; height:33px;" alt="Twitter"></a></li>
          <li class="smWhatsApp"><a :href="'whatsapp://send?text=' + shareUrl " target="_blank"><img src="static/letsfamily-de/img/WhatsApp.svg" class="dummySM" style="width:33px; height:33px;" alt="WhatsApp"></a></li>
        </ul>
      </div>

      <div class="backToSite PSBlock">
        <h3 class="blockHeading"><span>{{ $t('participation.success.heading_or') }}</span></h3>
        <p>{{ $t('participation.success.back_to_site_hint')}}</p>
        <a class="btn-primary" :href="moreCampaigns" target="_blank">{{ $t('participation.success.back_to_site_cta') }}</a>
      </div>
    </div>
    <div class="buttonAlignRight" style="margin-top:10px">
      <button @click="closeOverlay" >{{ $t('participation.success.btn_close') }}</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PostParticipation',
  props: ['result','merchantImage','moreCampaigns'],
  data: function() { return {
    redirectTimer: 10,
    redirectLeft: 9,
    redirectPaused: false
  }},
  computed: {
    shareUrl() {
      return window.location.href
    },
    maybeFree() {
      return this.result.campaign_type === 'coupon/free' ? '_free' : '' ;
    }
  },
  methods: {
    abortRedirectTimer(){
      this.redirectPaused = !this.redirectPaused;
    },
    decTimeLeft(){
      this.redirectLeft = this.redirectLeft - 1;
    },
    participateAgain() {
      this.redirectPaused = true;
      let reset = 9 - this.redirectLeft;
      this.$refs.countdown.updateTime(reset);
      this.redirectLeft = 9;
      this.redirectPaused = false;
      this.$emit('participate-again',1);
    },
    goToLandingpage(){
      window.location.href = this.result.landing_page;
    },
    closeOverlay(fragment){
      this.abortRedirectTimer();
      document.body.classList.remove('formularContent');
      document.getElementById("popup-message-background").classList.remove('active');
      let target = window.location.pathname;
      if (fragment) {
        target = target + '#' + fragment
      }
      window.location = target;
      window.location.reload(true);
    },
    copyToClipboard(code){
      navigator.clipboard.writeText(code);
    }
  }
}
</script>

<style scoped>
.timer {
  text-align: center;
}

.btn-secondary {
border:1px solid
}
</style>
